import ApiRequestManagerInstance from '../ApiRequestManager';
import ChannelUtils from '@shared/utils/channels';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IKeepWatchingRequest } from '../../types/interfaces/rail';
import { ParentalAge } from '@shared/types/enums/parental';
import { RailDisplayMode, RailType } from '../../types/enums/rail';
import { setKeepWatchingData } from '../../store/slices/keepWatching.slice';
import { store } from '../../store/store';

function keepWatchingRequest() {
  const promise = new Promise<Rail | null>(async (resolve) => {
    try {
      const { user } = store.getState();
      const checkAnonymous = user.isAnonymous ? true : false;
      if (checkAnonymous) {
        resolve(null);
        return;
      }
      const response: IKeepWatchingRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            version: 'v4',
            section: 'user',
            subsection: 'playbacks',
            type: '0',
          },
        })) as unknown as IKeepWatchingRequest;
      const shows = response.data
        .map((item) => {
          const newData = {
            ...item.shows,
            seguirViendoSeconds: item.seguirViendoSeconds,
          };
          return newData;
        })
        .filter((item) => {
          // Filter adult content
          if (
            item?.ageCode &&
            item?.ageCode?.toUpperCase() === ParentalAge.ADULTS
          ) {
            return false;
          }

          // Filter content from adult channels
          const channel = ChannelUtils.findChannel(item?.channel || '');
          if (channel?.parentalControl) {
            return false;
          }

          return true;
        });
      if (!shows.length) {
        resolve(null);
        store.dispatch(setKeepWatchingData({ shows, rail: undefined }));
        return;
      }
      const keepWatchingRail = {
        reloadable: true,
        section: {
          title: TranslationManager.get('COMPONENTS.RAILS.TITLE.KEEP_WATCHING'),
          presentationType: RailDisplayMode.PHOTO,
          name: 'keepWatchingRail',
        },
        shows: { data: shows },
      };
      const rail = new Rail(keepWatchingRail, null, RailType.KEEP_WATCHING);
      resolve(rail);
      store.dispatch(setKeepWatchingData({ shows, rail }));
    } catch (e) {
      console.error(e);
      resolve(null);
    }
  });

  return promise;
}

export default keepWatchingRequest;
